var MENTION_REGEXP = /<span\s+[^>]*class\s*=\s*["']?mention["']?[^>]*>.*?<\/span>.?<\/span>/gi;
export var getTextWithoutMentions = function (value) { return value.replace(MENTION_REGEXP, ''); };
